import { render, staticRenderFns } from "./CustomerInvoiceDetails.vue?vue&type=template&id=45685564&scoped=true"
import script from "./CustomerInvoiceDetails.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomerInvoiceDetails.vue?vue&type=style&index=0&id=45685564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45685564",
  null
  
)

export default component.exports